<template>
  <div>
    <data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination" class="order_offer_table">
      <v-container fluid grid-list-xl slot="filterForm" class="pa-0">
        <v-row class="pa-1 pl-2">
          <v-col cols="12" lg="1" sm="3" xs="6">
            <v-switch v-model="showAll" color="primary" @change="getListHandler" inset :label="$t('message.order.myTasks')" class="ma-0 ml-3"></v-switch>
          </v-col>
          <v-col cols="12" lg="1" sm="4" xs="6">
            <v-btn fab dark small color="success" :loading="loadingForExcel" class="ml-10">
              <v-icon dark @click="generateXslx" id="generateexcel">mdi-file-excel</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" lg="2" sm="4" xs="6">
            <v-autocomplete clearable v-model="filterObj.customerid" @change="getListHandler" autocomplete="off" :items="listOfCustomers" item-text="name" item-value="id" :label="$t('message.order.customer')" dense hide-details outlined></v-autocomplete>
          </v-col>
          <v-col cols="12" lg="2" sm="4" xs="6">
            <v-autocomplete clearable v-model="filterObj.responsibleid" @change="getListHandler" autocomplete="off" :items="listOfUsers" item-text="fullname" item-value="id" :label="$t('message.deviations.responsible')" dense hide-details outlined ></v-autocomplete>
          </v-col>
          <v-col cols="12" lg="2" sm="4" xs="6">
            <v-autocomplete clearable v-model="filterObj.status" multiple @change="getListHandler" autocomplete="off" :items="$_salesOrderStatus" item-text="name" item-value="id" :label="$t('message.layout.status')" dense hide-details outlined>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.name }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(+{{ filterObj.status.length - 1 }} {{ $t('message.common.others') }})</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" lg="2" sm="4" xs="6" class="text-right">
            <v-text-field append-icon="search" outlined dense single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right" id="searchbtn" hide-details ></v-text-field>
          </v-col>
          <v-col cols="12" lg="2" sm="4" xs="6" class="text-right">
            <v-text-field append-icon="search" outlined dense single-line v-model="productSearch" :label="$t('message.stock.winOrProduct')" class="text-xs-right" id="searchbtn" hide-details ></v-text-field>
          </v-col>
        </v-row>
    </v-container>
    <template slot="expand">
        <v-progress-linear class="mt-1 mb-1" indeterminate v-if="salesDataLoading"></v-progress-linear>
      <v-simple-table dense width="80%" class="dense_table bordered--table">
        <thead>
          <tr>
            <th v-for="(expandHeader, index) in expandHeader" :width="expandHeader.width" :key="index">{{ expandHeader.text }}</th>
          </tr>
        </thead>
        <tbody v-for="(expandList, index) in listPayloadObj.expanded" :key="index">
          <tr v-for="(item, i) in listOfMaterials" :key="`${i}_win`">
            <td v-for="(head, j) in expandHeader" :key="`${j}_item`">{{ item[head.value] }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </template>
    </data-list>
    <v-dialog v-model="shareDialog" persistent max-width="500px" class="mt-0">
      <v-form ref="shareForm" onSubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('message.common.addNew') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row>
                <v-text-field outlined dense v-model="mails" ref="autoFocus" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.common.add_extra_mails')"></v-text-field>
              </v-row>
              <v-row>
                <v-checkbox dense :label="$t('message.common.copy_to_me')" v-model="isCopyToMe" hide-details color="primary"></v-checkbox>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="sendMail" :loading="shareLoading" @click="shareReport">{{ $t('message.common.send') }}</v-btn>
            <v-btn color="error" id="close" @click="closeShareDialog">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import DataList from '@/components/DataList.vue'
import { mapState } from 'vuex'
import orderReport from '@/mixins/Order/report'
import packReport from '@/mixins/Order/packing_list'
import axios from 'axios'
export default {
  data () {
    return {
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        hasFilters: true,
        showSelect: false,
        expand: true,
        isOffer: true,
        addNewRoute: () => false,
        onExpand: ({ item }) => this.getOrderMaterials(item),
        list: [],
        loading: true,
        editProp: 'number',
        editURL: (item) => `/orders/actions/${item.id}`,
        changeState: this.changeOrderStatus,
        actionsList: [{
          click: (item) => this.printOrder(item),
          icon: () => 'mdi-arrow-down-bold-circle-outline',
          is_show: () => true
        }, {
          click: (item) => this.sendReport(item),
          icon: () => 'mdi-email-variant',
          is_show: () => true
        }, {
          click: (item) => this.downloadPackingList(item),
          icon: () => 'mdi-briefcase-download',
          is_show: (item) => item.haspickedqty
        }, {
          click: (item) => this.deleteOrder(item),
          icon: () => 'mdi-trash-can-outline',
          is_show: (item) => item.candelete
        }]
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.DEVIATION_ORDER_INDEX) ? this.$store.state.DEVIATION_ORDER_INDEX : { sortBy: ['number'], itemsPerPage: 25, sortDesc: [true], search: '' },
      MODULE: 'orders',
      state: this.$route.params.type,
      shareDialog: false,
      isCopyToMe: false,
      mails: '',
      orderModel: {},
      shareLoading: false,
      showAll: false,
      search: '',
      filterObj: {
        customerid: 0
      },
      salesDataLoading: false,
      listOfMaterials: [],
      productSearch: '',
      isfilterapplied: false,
      loadingForExcel: false
    }
  },
  components: {
    DataList
  },
  computed: {
    ...mapState(['DEVIATION_ORDER_INDEX', 'listOfUsers', 'listOfCustomers']),
    headers () {
      return [{
        text: this.$t('message.product.number'),
        value: 'number',
        width: '8%'
      }, {
        text: this.$t('message.tickets.status'),
        value: 'state',
        width: '10%'
      }, {
        text: this.$t('message.order.customer'),
        value: 'customername',
        width: '25%'
      }, {
        text: this.$t('message.orders.contact'),
        value: 'contactname',
        width: '15%'
      }, {
        text: this.$t('message.orders.deliveryAddress'),
        value: 'deliveryaddress',
        width: '15%'
      }, {
        text: this.$t('message.deviations.responsible'),
        value: 'responsiblename',
        width: '10%'
      }, {
        text: this.$t('message.layout.order'),
        value: 'orderdate',
        width: '8%'
      }, {
        text: this.$t('message.customer.delivery'),
        value: 'deliverydate',
        width: '8%'
      }]
    },
    types () {
      return [{
        name: this.$t('message.layout.offer'),
        value: 'offer'
      }, {
        name: this.$t('message.layout.order'),
        value: 'order'
      }, {
        name: this.$t('message.common.both'),
        value: ''
      }]
    },
    expandHeader () {
      return [{
        text: this.$t('message.orders.productNo'),
        value: 'number',
        width: '10%'
      }, {
        text: this.$t('message.mailConfiguration.name'),
        value: 'producttext',
        width: '10%'
      }, {
        text: this.$t('message.product.unit'),
        value: 'productunit_name',
        width: '10%'
      }, {
        text: this.$t('message.whOrder.orderQty'),
        value: 'qty',
        width: '10%'
      }, {
        text: this.$t('message.orders.pQty'),
        value: 'pickedqty',
        width: '10%'
      }, {
        text: this.$t('message.layout.warehouse'),
        value: 'warehouse_name',
        width: '10%'
      }, {
        text: this.$t('message.stock.location'),
        value: 'warehouselocation_name',
        width: '10%'
      }, {
        text: this.$t('message.stock.batchOrWin'),
        value: 'batchnumber',
        width: '10%'
      }]
    }
  },
  watch: {
    pagination (val) {
      const model = { type: 'DEVIATION_ORDER_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    },
    search: function (newValue, oldValue) {
      if (!this.isfilterapplied) this.getListHandler()
    },
    productSearch: function (newValue, oldValue) {
      if (!this.isfilterapplied) this.getListHandler()
    }
  },
  mixins: [orderReport, packReport],
  mounted () {
    const customerId = this.$route.query.customer
    if (customerId) {
      this.filterObj.customerid = +customerId
    }
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        const payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
        this.$eventBus.$emit('reRenderOrderModule')
      }
    })
    this.$store.dispatch('getCustomersList')
    this.$store.dispatch('getUsers')
    if (!this.$formatter.isEmptyObject(this.$store.state.F_SALES_ORDER)) {
      const order = this.$formatter.cloneVariable(this.$store.state.F_SALES_ORDER)
      this.filterObj = order.filter
      this.search = order.filter.search || ''
      this.productSearch = order.filter.materialsearch || ''
      this.isfilterapplied = true
    } else {
      this.filterObj.status = ['new', 'stock_available', 'planned', 'to_be_shipped', 'shipped']
    }
  },
  methods: {
    getListHandler () {
      const { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let sortByValue = ''
      if (sortBy && sortBy[0] && sortBy[0] === 'type_name') sortByValue = 'type'
      else if (sortBy && sortBy[0]) sortByValue = sortBy[0]
      const getIds = this.$route.query.ids || null
      const modelObj = {
        descending: sortDesc && sortDesc[0],
        page,
        sortby: sortByValue,
        search: this.search,
        rowsperpage: itemsPerPage,
        status: this.filterObj.status || [],
        responsibleid: this.filterObj.responsibleid || 0,
        customerid: this.filterObj.customerid || 0,
        type: this.filterObj.type || null,
        ordermaterialsearch: this.productSearch || '',
        ids: getIds ? JSON.parse(getIds) : []
      }
      const userId = this.$store.state.userDetails.id !== -100 ? this.$store.state.userDetails.id : 0
      if (this.showAll) modelObj.responsibleid = userId
      this.$_executeApi('post', 'orders/paginate_filter', modelObj)
        .then((response) => {
          const { items, total } = response.data
          this.listPayloadObj.loading = false
          const transformData = {
            date: { list: ['orderdate', 'deliverydate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' },
            number: { list: ['totalsum', 'totalvat', 'dg'], format: 'replaceDotWithComma' }
          }
          const model = this.$_formatListModel(items, transformData)
          model.map(x => {
            x.status = x.state
            const getStatusName = this.getStatusName(x.state)
            x.state = getStatusName ? getStatusName.name : x.state
            const getType = this.getTypeName(x.type)
            x.type_name = getType ? getType.name : x.type
            return x
          })
          this.listPayloadObj.state = model.state
          this.listPayloadObj.list = model
          this.total = total
          if (modelObj.page > 1 && this.total <= modelObj.rowsperpage * (modelObj.page - 1)) {
            this.pagination.page = 1
            this.listPayloadObj.page = 1
          }
          this.listPayloadObj.selection = []
          const filterData = { type: 'F_SALES_ORDER', data: { filter: { ...this.filterObj, search: this.search || '', materialsearch: this.productSearch || '' } } }
          this.$store.commit('rememberFilter', filterData)
          this.isfilterapplied = false
        })
    },
    deleteOrder (item) {
      const payload = { ids: [item.id], url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
      this.$store.commit('showDeleteDialog', payload)
    },
    async printOrder (item) {
      this.listPayloadObj.loading = true
      const getTypeObj = this.getTypeName(item.type)
      const model = {
        visiblefilename: `${getTypeObj ? getTypeObj.name + '_' : ' '}${item.number}`,
        content: await this.genereateReportContent(item.id)
      }
      this.$_executeApi('post', `orders/generate_pdf/${item.id}`, model)
        .then((response) => {
          const fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
        .finally(() => {
          this.listPayloadObj.loading = false
        })
    },
    generateXslx () {
      this.loadingForExcel = true
      this.$_executeApi('get', 'orders/generate_product_tobe_sold_report')
        .then(response => {
          window.open(process.env.VUE_APP_URL + 'file/download?fileName=' + response.data, '_blank')
        })
        .finally(() => {
          this.loadingForExcel = false
        })
    },
    async downloadPackingList (item) {
      this.listPayloadObj.loading = true
      this.$_executeApi('post', 'orders/generate_packing_report', { visiblefilename: `Pakkseddel_${item.number}`, content: await this.genereatePackReportContent(item.id) })
        .then((response) => {
          const fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
        .finally(() => {
          this.listPayloadObj.loading = false
        })
    },
    async sendReport (item) {
      this.shareDialog = true
      this.mails = item.contact_email || ''
      this.orderModel = item
    },
    async shareReport () {
      if (this.$refs.shareForm.validate()) {
        this.shareLoading = true
        if (!this.mails.length > 0) this.isValidEmail = true
        const getMailIDsString = this.mails
        const listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds && listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              this.validEmail(listOfMailIds[i]) ? this.isValidEmail = false : this.isValidEmail = true
            }
          }
        }
        if (!this.isValidEmail) {
          const currentUserMail = this.$store.state.userDetails ? this.$store.state.userDetails.email : ''
          this.shareLoading = true
          const getTypeObj = this.getTypeName(this.orderModel.type)
          const visibleFileName = `${getTypeObj ? getTypeObj.name : ''}_${this.orderModel.number}`
          this.$_executeApi('post', `orders/generate_pdf/${this.orderModel.id}`, { visiblefilename: visibleFileName, content: await this.genereateReportContent(this.orderModel.id) })
            .then((response) => {
              const fileName = response.data
              const model = { subject: `NOSO AS ${visibleFileName}`, to: listOfMailIds, cc: this.isCopyToMe && currentUserMail ? [currentUserMail] : [], filename: fileName }
              this.$_executeApi('post', `${this.MODULE}/share/${this.orderModel.id}`, model)
                .then((response) => {
                  this.closeShareDialog()
                  this.shareLoading = false
                  this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.tickets.sentSuccess') })
                })
            })
            .catch(() => {
              this.shareLoading = false
            })
        } else {
          this.shareLoading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
        }
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    closeShareDialog () {
      this.mails = ''
      this.shareDialog = false
      this.orderModel = {}
    },
    changeOrderStatus (ids) {
      this.$_executeApi('post', 'orders/invoice', ids)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
        })
        .finally(() => {
          this.getListHandler()
        })
    },
    getOrderMaterials (item) {
      this.salesDataLoading = true
      const query = {
        expand: [{
          select: ['id'],
          model: 'Product',
          on_field: 'id',
          on_parent_field: 'productid',
          inner_expand: {
            select: ['name'],
            model: 'ProductUnit',
            on_field: 'id',
            on_parent_field: 'unitid'
          }
        }, {
          select: ['name'],
          model: 'Warehouse',
          on_field: 'id',
          on_parent_field: 'warehouseid'
        }, {
          select: ['name'],
          model: 'WarehouseLocation',
          on_field: 'id',
          on_parent_field: 'locationid'
        }],
        filter: `orderid eq '${item.id}'`
      }
      this.$_executeApi('post', 'ordermaterials/query', query)
        .then(async (response) => {
          const list = response.data
          const transformData = { number: { list: ['qty', 'pickedqty', 'invoiceqty', 'price', 'costprice', 'discount', 'total', 'dg'], format: 'replaceDotWithComma' } }
          const model = this.$_formatListModel(list, transformData)
          this.listOfMaterials = model
        })
        .finally(() => {
          this.salesDataLoading = false
        })
    },
    getStatusName (state) {
      return this.$_findValueInArray(this.$_salesOrderStatus, x => x.id === state)
    },
    getTypeName (type) {
      return this.$_findValueInArray(this.types, x => x.value === type)
    },
    /* eslint-disable */
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
<style>
  .order_offer_table .v-data-table td, .order_offer_table .v-data-table th {
    padding: 0 6px !important;
  }
</style>
